// extracted by mini-css-extract-plugin
export var addToCartButton = "_tp-b";
export var arrowButtonContainer = "_tp-9";
export var arrowButtonIcon = "_tp-a";
export var carouselArrowButton = "_tp-6";
export var carouselElementContainer = "_tp-1";
export var left = "_tp-7";
export var productDisplayCarouselContainer = "_tp-0";
export var productTileContainer = "_tp-2";
export var productTileImage = "_tp-4";
export var productTileImageContainer = "_tp-3";
export var productTileTitle = "_tp-5";
export var right = "_tp-8";
export var sliderOverflow = "_tp-c";